module.exports = __webpack_public_path__ + "img/OT287896.859de00.jpg";